module.exports = __webpack_public_path__ + "static/plaque-example-790de8be16dae4594a5751afc656c27c.png";